export enum EnvironmentTypes {
  Staging = 'staging',
  Production = 'production',
  Development = 'development'
}
